import {
  Stack,
  Button,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  Typography,
  Grid,
  Chip,
  Autocomplete,
} from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"
import { DatePicker } from "../ui/DateTimePickers"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import FormItem from "../ui/FormItem"
import { Auth } from "aws-amplify"
import {
  createEmploymentContract,
  editStaff,
  searchInstitutes,
} from "../../api"
import AddEmployeeAccount from "./AddEmployeeAccount"
import AddQualification from "./AddQualification"
import AddExperience from "./AddExperience"
import { uploadInvoiceFile } from "../../utilities"
import { DropzoneArea } from "mui-file-dropzone"

const steps = ["Basic Details", "Personal Details", "Employment Details"]

// 3ba8f73d-5cb7-4052-8c73-ad474346538c
// b9695c83-8d8d-4137-b04d-13f10f470701

const AddStaff = ({ admissionData, ...props }) => {
  const [activeStep, setActiveStep] = useState(0)
  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    phoneNumber: "",
    type: "STAFF",
    qualification: "",
    alternateNumber: "",
    address: "",
    pan: "",
    aadhar: "",
    accountId: "",
    fatherName: "",
    motherName: "",
    employmentQualifications: [],
    employmentExperiences: [],
    contractStartDate: new Date(),
    contractEndDate: "",
    termination: "",
    reason: "",
    designation: "",
  })
  const [staffID, setStaffID] = useState(null)
  const [addAccountModal, setAddAccountModal] = useState(false)
  const [addQualification, setAddQualification] = useState(false)
  const [addExperience, setAddExperience] = useState(false)

  const handleNext = async () => {
    if (activeStep === 0) signUp()
    else if (activeStep === 1) addPersonalDetails()
    else if (activeStep === 2) addContract()
  }

  const handlePrev = async () => {
    if (activeStep === 0) props.close()
    else if (activeStep === 1) setActiveStep(0)
    else if (activeStep === 2) setActiveStep(1)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const signUp = async () => {
    setLoading(true)
    try {
      const newStaff = await Auth.signUp({
        username: formData.username,
        password: formData.password,
        attributes: {
          name: formData.name,
          email: formData.email,
          phone_number: formData.phoneNumber,
          "custom:type": formData.type,
        },
      })
      setStaffID(newStaff.userSub)
      enqueueSnackbar("Staff registered.", { variant: "success" })
      setLoading(false)
      setActiveStep(1)
    } catch (e) {
      console.log(e)
      enqueueSnackbar(e.message, { variant: "error" })
      setLoading(false)
    }
  }

  const addPersonalDetails = async () => {
    setLoading(true)
    const data = {
      id: staffID,
      fatherName: formData.fatherName,
      motherName: formData.motherName,
      alternateNumber: formData.alternateNumber,
      address: formData.address,
      emergencyContact: formData.emergencyContact,
      emergencyContactName: formData.emergencyContactName,
      emergencyContactRelation: formData.emergencyContactRelation,
      category: formData.category,
    }

    editStaff(data)
      .then(() => {
        enqueueSnackbar("Personal details added.", { variant: "success" })
        setLoading(false)
        setActiveStep(2)
      })
      .catch((e) => {
        console.log(e)
        enqueueSnackbar(e.data, { variant: "error" })
        setLoading(false)
      })
  }

  const addContract = async () => {
    setLoading(true)
    const data = {
      employee: staffID,
      contractStartDate: formData.contractStartDate,
      contractEndDate: formData.contractEndDate,
      designation: formData.designation,
      employmentQualifications: formData.employmentQualifications,
      employmentExperiences: formData.employmentExperiences,
      termination: formData.termination,
      reason: formData.reason,
      accountId: formData.accountId,
      aadhar: formData.aadhar,
      pan: formData.pan,
      instituteId: formData?.instituteId || "",
      contractDocument: formData?.contractDocument || "",
    }

    if (invoiceFile !== null && invoiceFile.length > 0) {
      uploadInvoiceFile(invoiceFile[0])
        .then((res) =>
          createEmploymentContract({
            ...data,
            contractDocument: res?.data?.billUrl,
          })
        )
        .then(() => {
          enqueueSnackbar("Employment details added", { variant: "success" })
          setLoading(false)
          props.close()
        })
        .catch((e) => enqueueSnackbar(e.data, { variant: "error" }))
        .finally(() => setLoading(false))
    } else {
      createEmploymentContract(data)
        .then(() => {
          enqueueSnackbar("Employment details added", { variant: "success" })
          setLoading(false)
          props.close()
        })
        .catch((e) => enqueueSnackbar(e.data, { variant: "error" }))
        .finally(() => setLoading(false))
    }
  }

  const removeQualification = (i) => {
    setFormData({
      ...formData,
      employmentQualifications: [
        ...formData.employmentQualifications.slice(0, i),
        ...formData.employmentQualifications.slice(i + 1),
      ],
    })
  }

  const removeExperience = (i) => {
    setFormData({
      ...formData,
      employ: [
        ...formData.employmentExperiences.slice(0, i),
        ...formData.employmentExperiences.slice(i + 1),
      ],
    })
  }

  const [institute, setInstitute] = useState("")
  const [institutes, setInstitutes] = useState([])
  const [serachLoading, setSerachLoading] = useState(false)

  const fetchInstitutes = (value) => {
    setSerachLoading(true)
    searchInstitutes(value)
      .then((res) =>
        setInstitutes(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => console.log(err))
      .finally(() => setSerachLoading(false))
  }

  const [invoiceFile, setInvoiceFile] = useState(null)
  const uploadInvoice = (event) => setInvoiceFile(event)

  return (
    <Modal
      {...props}
      title="Add Staff"
      actionText={activeStep === steps.length - 1 ? "Finish" : "Next"}
      action={handleNext}
      cancelText={activeStep === 0 ? "Cancel" : "Previous"}
      cancelAction={handlePrev}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Stack spacing={2} marginTop={2}>
          {/*------------------------- FIRST STEP -> BASIC DETAILS----------------------------------- */}
          {activeStep === 0 && (
            <>
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              <TextField
                label="Username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              <TextField
                label="Password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <TextField
                label="Phone"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </>
          )}
          {/*------------------------- SECOND STEP -> PERSONAL DETAILS----------------------------------- */}
          {activeStep === 1 && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Father's name"
                    name="fatherName"
                    value={formData.fatherName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Mother's name"
                    name="motherName"
                    value={formData.motherName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Alternate number"
                    name="alternateNumber"
                    value={formData.alternateNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Emergency Contact No."
                    name="emergencyContact"
                    value={formData.emergencyContact}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Emergency Contact Relation"
                    name="emergencyContactRelation"
                    value={formData.emergencyContactRelation}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Emergency Contact Name"
                    name="emergencyContactName"
                    value={formData.emergencyContactName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormItem label="Category">
                    <Select
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                    >
                      {["GENERAL", "SC", "ST", "OBC"].map((p) => (
                        <MenuItem value={p}>{p}</MenuItem>
                      ))}
                    </Select>
                  </FormItem>
                </Grid>
              </Grid>
            </>
          )}
          {/*------------------------- THIRD STEP -> CONTRACT DETAILS----------------------------------- */}
          {activeStep === 2 && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormItem label="Designation">
                    <TextField
                      fullWidth
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem label="Institute">
                    <Autocomplete
                      loading={serachLoading}
                      value={formData.instituteId}
                      onChange={(_, val) => {
                        setFormData({
                          ...formData,
                          instituteId: val.id,
                        })
                      }}
                      inputValue={institute}
                      onInputChange={(_, val) => {
                        setInstitute(val)
                        fetchInstitutes(val)
                      }}
                      getOptionLabel={(option) => option.label}
                      options={institutes}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem label="Joining Date">
                    <DatePicker
                      value={formData.contractStartDate}
                      onChange={(date) =>
                        setFormData({
                          ...formData,
                          contractStartDate: date,
                        })
                      }
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem label="Last Working Date">
                    <DatePicker
                      value={formData.contractEndDate}
                      onChange={(date) =>
                        setFormData({
                          ...formData,
                          contractEndDate: date,
                        })
                      }
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Aadhar No."
                    name="aadhar"
                    value={formData.aadhar}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="PAN"
                    name="pan"
                    value={formData.pan}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    disabled={formData.accountId}
                    onClick={() => setAddAccountModal(true)}
                    fullWidth
                    variant="outlined"
                    sx={{ height: "100%" }}
                  >
                    {formData.accountId ? "Account Added!" : "Add Account"}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <FormItem label="Termination">
                    <Select
                      name="termination"
                      value={formData.termination}
                      onChange={handleChange}
                    >
                      {["RESIGNED", "TERMINATED"].map((p) => (
                        <MenuItem value={p}>{p}</MenuItem>
                      ))}
                    </Select>
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem label="Reason for termination">
                    <TextField
                      fullWidth
                      name="reason"
                      value={formData.reason}
                      onChange={handleChange}
                    />
                  </FormItem>
                </Grid>
              </Grid>
              <Typography>Qualifications:</Typography>
              {!!formData.employmentQualifications.length && (
                <Stack direction="row" gap={1} flexWrap={"wrap"}>
                  {formData.employmentQualifications.map((e, i) => (
                    <Chip
                      label={
                        e.qualification +
                        (e.specilisation ? " (" + e.specilisation + ")" : "") +
                        " • " +
                        e.passingYear
                      }
                      onDelete={() => removeQualification(i)}
                    />
                  ))}
                </Stack>
              )}
              <Button
                onClick={() => setAddQualification(true)}
                variant="outlined"
              >
                Add Qualification
              </Button>
              <Typography>Employment Experience:</Typography>
              {!!formData.employmentExperiences.length && (
                <Stack direction="row" gap={1} flexWrap={"wrap"}>
                  {formData.employmentExperiences.map((e, i) => (
                    <Chip
                      label={e.designation + " at " + e.employer}
                      onDelete={() => removeExperience(i)}
                    />
                  ))}
                </Stack>
              )}
              <Button onClick={() => setAddExperience(true)} variant="outlined">
                Add Experience
              </Button>
              <FormItem label="Upload Staff Onboarding Form">
                <DropzoneArea
                  filesLimit={1}
                  onChange={uploadInvoice}
                  acceptedFiles={["application/pdf"]}
                  useChipsForPreview
                />
              </FormItem>{" "}
            </>
          )}
        </Stack>
      </LocalizationProvider>
      <AddEmployeeAccount
        isOpen={addAccountModal}
        close={() => setAddAccountModal(false)}
        add={(data) =>
          setFormData({
            ...formData,
            employeeAccount: data,
          })
        }
      />
      <AddQualification
        isOpen={addQualification}
        close={() => setAddQualification(false)}
        add={(data) =>
          setFormData({
            ...formData,
            employmentQualifications: [
              ...formData.employmentQualifications,
              data,
            ],
          })
        }
      />
      <AddExperience
        isOpen={addExperience}
        close={() => setAddExperience(false)}
        add={(data) =>
          setFormData({
            ...formData,
            employmentExperiences: [...formData.employmentExperiences, data],
          })
        }
      />
    </Modal>
  )
}

export default AddStaff
